var MAX_SPACE_TRESHOLD = 0.2;
export var setYLabelsDimension = function (_a) {
    var svgDimensions = _a.svgDimensions, axisTheme = _a.axisTheme;
    var labelsEnabled = axisTheme.labels.enabled;
    if (!labelsEnabled)
        return null;
    return MAX_SPACE_TRESHOLD * svgDimensions.width;
};
export var setXLabelsDimension = function (_a) {
    var scale = _a.scale, axisTheme = _a.axisTheme, svgDimensions = _a.svgDimensions;
    var _b = axisTheme.labels, radiusAngle = _b.radiusAngle, labelsEnabled = _b.enabled;
    if (!labelsEnabled)
        return null;
    if (radiusAngle === 0) {
        if ('bandwidth' in scale) {
            return scale.bandwidth();
        }
        return null;
    }
    return MAX_SPACE_TRESHOLD * svgDimensions.height;
};
